import React from "react";
import PropTypes from "prop-types";

const ShiftIconFilled = ({ viewBox = "0 0 32 32", width = 24, height = 24, fill = "currentColor" }) => (
    <svg width={width} height={height} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg" fill={fill}>
        <path d="M16 4L4 16h6v12h12V16h6L16 4z" />
    </svg>
);
ShiftIconFilled.propTypes = {
    viewBox: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
    fill: PropTypes.any
};

export default ShiftIconFilled;
